import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';
import { StackLayout, Text } from '@wemogy/reactbase';
import useAuthorizationTheme from '../../../theme/UseAuthorizationTheme';
var PermissionListItem = function (props) {
    var permissionLevel = props.permissionLevel, permissionEnumValue = props.permissionEnumValue, role = props.role, onPress = props.onPress;
    var staticPermission = useMemo(function () {
        if (!permissionLevel.staticPermissions) {
            return undefined;
        }
        return permissionLevel.staticPermissions.find(function (staticPermission) { return staticPermission.permissionFlag === permissionEnumValue; });
    }, [permissionLevel, permissionEnumValue]);
    var activeRole = role.getLevelRole(permissionLevel.pathIndex, permissionLevel.levelIndex);
    // numeric access to enum value will return the key as string
    var descriptionTranslationKey = useMemo(function () { return "" + permissionLevel.translationPrefix + _.camelCase(permissionLevel.permissionEnum[permissionEnumValue]); }, [permissionLevel]);
    var isEnabled = staticPermission === undefined ? activeRole.hasFlag(permissionEnumValue) : staticPermission === null || staticPermission === void 0 ? void 0 : staticPermission.defaultValue;
    var theme = useAuthorizationTheme().permissionListItem;
    var handlePress = useCallback(function () {
        if (!onPress) {
            return;
        }
        onPress(permissionLevel, permissionEnumValue);
    }, [onPress, permissionLevel, permissionEnumValue]);
    return (React.createElement(StackLayout, { paddingBottom: true },
        React.createElement(StackLayout, { horizontal: true, borderRadius: true, padding: true, vCenter: true, onPress: onPress && !staticPermission ? handlePress : undefined, overflow: "hidden", backgroundColor: isEnabled ? theme.enabledColor : theme.disabledColor },
            React.createElement(Text, { stretch: true, overflowEllipsis: true, variationKey: isEnabled ? theme.enabledTextVariation : theme.disabledTextVariation }, descriptionTranslationKey))));
};
export default observer(PermissionListItem);
//# sourceMappingURL=PermissionListItem.js.map